import { jsx as _jsx } from "react/jsx-runtime";
import React, { useImperativeHandle, useRef, useState } from "react";
import ConsignmentPhotoList, {} from "./ConsignmentPhotoList";
import ConsignmentImageKind from "../../enums/ConsignmentImageKind";
import { userHasPermission } from "../../../../swzutils/UserPermissionsUtil";
import { Button, Popconfirm, Spin } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import { useAppSelector } from "../../../../store";
import { loggedInUserSelector } from "../../../../store/slice/auth";
const ConsignmentPhotoListEditable = React.forwardRef((props, exportedRef) => {
    const consignmentPhotoListRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    useImperativeHandle(exportedRef, () => ({
        refresh: () => {
            consignmentPhotoListRef.current.refresh();
        }
    }));
    const doDelete = (img) => {
        setLoading(true);
        axios.delete(`/admin/v1/consignments/${props.consignmentId}/images/${img.id}`)
            .then(() => {
            consignmentPhotoListRef.current.refresh();
            props.onPhotoDeleted();
        })
            .catch(axiosErrorHandler)
            .finally(() => {
            setLoading(false);
        });
    };
    return (_jsx(Spin, { spinning: loading, children: _jsx(ConsignmentPhotoList, { ref: consignmentPhotoListRef, consignmentId: props.consignmentId, consignmentVersion: props.consignmentVersion, filterKind: props.filterKind, renderActions: (img) => {
                if (userHasPermission(loggedInUser, ['admin:consignmentImage:delete'])) {
                    return ([
                        _jsx(Popconfirm, { title: "Delete this photo?", onConfirm: () => doDelete(img), okText: "Yes", cancelText: "No", children: _jsx(Button, { children: _jsx(DeleteOutlined, {}) }) })
                    ]);
                }
                return [];
            } }) }));
});
export default ConsignmentPhotoListEditable;
